import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2b435795"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrap_screen" }
const _hoisted_2 = { class: "status_bar" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "other_profile" }, " 아바타 커스텀보이스 ", -1))
const _hoisted_4 = { class: "scroll" }
const _hoisted_5 = { class: "wrap_chat_screen" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, [
  /*#__PURE__*/_createElementVNode("div", null, "학습을 진행할 커스텀 보이스 wav 파일을 선택해 주세요.")
], -1))
const _hoisted_7 = { class: "setting_box" }
const _hoisted_8 = { class: "setting_box" }
const _hoisted_9 = { class: "drag_drop" }
const _hoisted_10 = { class: "setting_box green" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "form-group" }, [
  /*#__PURE__*/_createElementVNode("label", null, "아바타를 선택하세요")
], -1))
const _hoisted_12 = { class: "drag_drop" }

import {
  onMounted,
  ref,
} from 'vue';
import { notification as AntNotification } from 'ant-design-vue/lib/components';
import { SelectProps } from 'ant-design-vue';
import {
  tabStore,
  userStore,
  tutorialStore,
} from '../stores/storeAuth';
import {
  postSpeakerAvatar,
  requestGetAvatarList,
} from '@apis/voicechat';


export default /*#__PURE__*/_defineComponent({
  __name: 'CustomVoiceLearning',
  setup(__props) {

const tabData = tabStore();
const showMobileMenu = () => {
  tabData.sideMenu = true;
};
const selectedAvatarId = ref(0);
const selectedFile = ref<File | null>(null);
const fileBase64String = ref<string | null>(null);
const fileInput = ref<HTMLInputElement | null>(null);

const convertToBase64 = (file: File) => {
  const reader = new FileReader();
  reader.onloadend = () => {
    // The result attribute contains the data as a base64 encoded string
    const base64String = reader.result as string;
    // eslint-disable-next-line
    fileBase64String.value = base64String.split(',')[1];

    console.log('audio base64', fileBase64String.value);
  };
  reader.readAsDataURL(file); // Read the file as a Data URL (Base64)
};
const handleDragOver = (event: DragEvent) => {
  event.preventDefault();
  console.log('drag over');
  if (event.dataTransfer) {
    // eslint-disable-next-line no-param-reassign
    event.dataTransfer.dropEffect = 'copy'; // Explicitly show this is a copy.
  }
};
const handleDrop = (event: DragEvent) => {
  event.preventDefault();
  if (event.dataTransfer && event.dataTransfer.files.length) {
    const file = event.dataTransfer.files[0];
    if (file.type === 'audio/wav') {
      selectedFile.value = file;
      convertToBase64(file);
    } else {
      alert('Please select a valid .wav file.');
      selectedFile.value = null;
    }
  }
};
const handleFileChange = (event: Event) => {
  const target = event.target as HTMLInputElement;
  if (target.files && target.files[0]) {
    const file = target.files[0];
    selectedFile.value = file;
    convertToBase64(file);
  }
};
const triggerFileInput = () => {
  selectedFile.value = null;
  fileInput.value?.click();
};
const clearFile = () => {
  selectedFile.value = null;
};
const persona = ref('');
const personaList = ref<SelectProps['options']>([{
  value: '',
  label: '--- 선택 ---',
}]);

const getAvatar = async () => {
  try {
    const result = await requestGetAvatarList(); // Corrected function name
    console.log(result.data.avatars, '💖💖');
    result.data.avatars.forEach((res: any) => {
      const temp = {
        value: res.id,
        label: res.name,
      };
      personaList.value!.push(temp);
    });
  } catch (error: any) {
    console.log(error.message);
  }
};

const selectAvatar = (avatarId: number) => {
  console.log('Selected Avatar ID:', avatarId);
  selectedAvatarId.value = avatarId;
};

const speakerSave = async () => {
  if (selectedAvatarId.value === 0) return;
  if (fileBase64String.value === '') return;
  const params = {
    audio_base64_string: fileBase64String.value,
    avatar_id: selectedAvatarId.value,
  };
  try {
    const result = await postSpeakerAvatar(params);
    AntNotification.error({ message: '성공적으로 저장하였습니다.' });
    console.log('postSpeakerAvatar result:', result);
  } catch (error: any) {
    AntNotification.error({ message: '음성 정보를 저장하는데 실패했습니다.' });
    console.log(error.message);
  }
};

onMounted(getAvatar);


return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_font_awesome_icon, {
        class: "chevron",
        icon: "fa-solid fa-bars",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (showMobileMenu()))
      }),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-cloud-arrow-up" }),
          _createElementVNode("div", {
            class: "drag_drop",
            onDragover: _withModifiers(handleDragOver, ["prevent"]),
            onDrop: _withModifiers(handleDrop, ["prevent"])
          }, " 파일을 선택하세요. ", 32),
          _createElementVNode("input", {
            ref_key: "fileInput",
            ref: fileInput,
            type: "file",
            accept: ".wav",
            hidden: "",
            onChange: handleFileChange
          }, null, 544),
          _createElementVNode("div", {
            id: "browseButton",
            class: "modal_cancel",
            onClick: triggerFileInput
          }, " 파일 업로드하기 ")
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-file" }),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", null, _toDisplayString(selectedFile.value?.name), 1)
          ]),
          _createVNode(_component_font_awesome_icon, {
            class: "button_close",
            icon: "fa-solid fa-xmark",
            onClick: clearFile
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_a_select, {
              ref: "select",
              value: persona.value,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((persona).value = $event)),
              class: "dropdown",
              options: personaList.value,
              onChange: selectAvatar
            }, null, 8, ["value", "options"])
          ]),
          _createElementVNode("div", {
            id: "browseButton",
            class: "button_okay",
            onClick: speakerSave
          }, " 커스텀보이스 저장 ")
        ])
      ])
    ])
  ]))
}
}

})